import React, { Component, PropTypes } from 'react';
import { Units } from 'Css';
import Thumb from './Thumb';

const css = oxygenCss({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: Units.base
  },
  thumb: {
    margin: Units.base
  }
});

class FileSelectorGrid extends Component {
  static propTypes = {
    items: PropTypes.array,
    changeDir: PropTypes.func,
    onSelect: PropTypes.func
  };

  handleTouchTap = item => {
    const { type, id } = item;
    if (type === 'dir') {
      const { changeDir } = this.props;
      changeDir(id);
    } else {
      const { onSelect } = this.props;
      onSelect && onSelect(item);
    }
  };

  render() {
    const { items } = this.props;
    return (
      <div className={css.container}>
        {items.map(item => {
          const { id, type, url } = item;
          return (
            <div className={css.thumb} key={id}>
              <Thumb
                type={type}
                url={url}
                size={2}
                onTouchTap={this.handleTouchTap}
                payload={item}
              />
            </div>
          );
        })}
      </div>
    );
  }
}

export default FileSelectorGrid;



// WEBPACK FOOTER //
// ./src/js/components/MediaLibrary/FileSelectorGrid.js